import { z } from 'zod';
import { BaseSchema } from './baseSchema';

export const FragmentSchema = z.object({
    video_url: z.string(),
    fragm: z.string().nullable().optional(),
});

export const AudiovisualTitleSchema = BaseSchema.extend({
    title: z.string(),
});
